import { useState } from 'react';
import styled from '@emotion/styled';
import type { SourceSnippet } from '@trinity/chat/types/extracted-answers.api';

const Container = styled.div`
  margin-top: 8px;
`;

const Toggle = styled.button`
  background: none;
  border: none;
  color: #1976d2;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
`;

const SnippetList = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const SnippetCard = styled.div`
  padding: 8px 12px;
  border-left: 3px solid #1976d2;
  background: #fafafa;
  border-radius: 0 4px 4px 0;
  font-size: 13px;
  line-height: 1.5;
`;

const SourceId = styled.span`
  font-size: 11px;
  color: #888;
  display: block;
  margin-top: 4px;
`;

type Props = {
  snippets: SourceSnippet[];
};

export function SourceSnippetPanel({ snippets }: Props): React.ReactElement | null {
  const [expanded, setExpanded] = useState(false);

  if (snippets.length === 0) return null;

  return (
    <Container>
      <Toggle onClick={() => setExpanded((v) => !v)}>
        {expanded ? 'Hide' : 'Show'} {snippets.length} source{snippets.length > 1 ? 's' : ''}
      </Toggle>
      {expanded && (
        <SnippetList>
          {snippets.map((s, i) => (
            <SnippetCard key={`${s.sourceId}-${i}`}>
              &ldquo;{s.sentence}&rdquo;
              <SourceId>{s.sourceId}</SourceId>
            </SnippetCard>
          ))}
        </SnippetList>
      )}
    </Container>
  );
}
